// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/runner.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { FieldValue, RunnerKind, RunnerProvider } from "./runner_configuration_pb.js";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { PullRequest } from "./agent_pb.js";
import { Subject } from "./identity_pb.js";
import { Gateway } from "./gateway_pb.js";

/**
 * @generated from enum gitpod.v1.LogLevel
 */
export enum LogLevel {
  /**
   * @generated from enum value: LOG_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOG_LEVEL_DEBUG = 1;
   */
  DEBUG = 1,

  /**
   * @generated from enum value: LOG_LEVEL_INFO = 2;
   */
  INFO = 2,

  /**
   * @generated from enum value: LOG_LEVEL_WARN = 3;
   */
  WARN = 3,

  /**
   * @generated from enum value: LOG_LEVEL_ERROR = 4;
   */
  ERROR = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(LogLevel)
proto3.util.setEnumType(LogLevel, "gitpod.v1.LogLevel", [
  { no: 0, name: "LOG_LEVEL_UNSPECIFIED" },
  { no: 1, name: "LOG_LEVEL_DEBUG" },
  { no: 2, name: "LOG_LEVEL_INFO" },
  { no: 3, name: "LOG_LEVEL_WARN" },
  { no: 4, name: "LOG_LEVEL_ERROR" },
]);

/**
 * @generated from enum gitpod.v1.SearchMode
 */
export enum SearchMode {
  /**
   * SEARCH_MODE_UNSPECIFIED defaults to KEYWORD for backward compatibility
   *
   * @generated from enum value: SEARCH_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * KEYWORD mode: Simple keyword search with automatic augmentation
   * - GitHub: Adds "user:<username>" and "is:public" qualifiers
   * - Bitbucket: Searches by name across user's accessible repositories
   * - GitLab: Not yet implemented
   *
   * @generated from enum value: SEARCH_MODE_KEYWORD = 1;
   */
  KEYWORD = 1,

  /**
   * NATIVE mode: Pass search_string directly to SCM's search API
   * - GitHub: Use GitHub's repository search syntax
   *   Examples: "org:gitpod-io language:go", "stars:>100 fork:true"
   * - Bitbucket: Use Bitbucket's query language
   *   Examples: "name~\"api\" AND project.key=\"PROJ\""
   * - GitLab: Use GitLab's search parameters
   *   Examples: "scope=projects&search=kubernetes"
   *
   * @generated from enum value: SEARCH_MODE_NATIVE = 2;
   */
  NATIVE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(SearchMode)
proto3.util.setEnumType(SearchMode, "gitpod.v1.SearchMode", [
  { no: 0, name: "SEARCH_MODE_UNSPECIFIED" },
  { no: 1, name: "SEARCH_MODE_KEYWORD" },
  { no: 2, name: "SEARCH_MODE_NATIVE" },
]);

/**
 * @generated from enum gitpod.v1.RunnerVariant
 */
export enum RunnerVariant {
  /**
   * @generated from enum value: RUNNER_VARIANT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RUNNER_VARIANT_STANDARD = 1;
   */
  STANDARD = 1,

  /**
   * @generated from enum value: RUNNER_VARIANT_ENTERPRISE = 2;
   */
  ENTERPRISE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(RunnerVariant)
proto3.util.setEnumType(RunnerVariant, "gitpod.v1.RunnerVariant", [
  { no: 0, name: "RUNNER_VARIANT_UNSPECIFIED" },
  { no: 1, name: "RUNNER_VARIANT_STANDARD" },
  { no: 2, name: "RUNNER_VARIANT_ENTERPRISE" },
]);

/**
 * @generated from enum gitpod.v1.RunnerReleaseChannel
 */
export enum RunnerReleaseChannel {
  /**
   * Invalid release channel
   *
   * @generated from enum value: RUNNER_RELEASE_CHANNEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The runner is on the stable release channel
   *
   * @generated from enum value: RUNNER_RELEASE_CHANNEL_STABLE = 1;
   */
  STABLE = 1,

  /**
   * The runner is on the latest release channel
   *
   * @generated from enum value: RUNNER_RELEASE_CHANNEL_LATEST = 2;
   */
  LATEST = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(RunnerReleaseChannel)
proto3.util.setEnumType(RunnerReleaseChannel, "gitpod.v1.RunnerReleaseChannel", [
  { no: 0, name: "RUNNER_RELEASE_CHANNEL_UNSPECIFIED" },
  { no: 1, name: "RUNNER_RELEASE_CHANNEL_STABLE" },
  { no: 2, name: "RUNNER_RELEASE_CHANNEL_LATEST" },
]);

/**
 * RunnerPhase represents the phase a runner is in
 *
 * @generated from enum gitpod.v1.RunnerPhase
 */
export enum RunnerPhase {
  /**
   * Invalid phase
   *
   * @generated from enum value: RUNNER_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The runner was created but not yet signed up
   *
   * @generated from enum value: RUNNER_PHASE_CREATED = 1;
   */
  CREATED = 1,

  /**
   * The runner was signed up and is ready to be used, but has not communicated with us yet
   *
   * @generated from enum value: RUNNER_PHASE_INACTIVE = 2;
   */
  INACTIVE = 2,

  /**
   * The runner was signed up and is ready to be used
   *
   * @generated from enum value: RUNNER_PHASE_ACTIVE = 3;
   */
  ACTIVE = 3,

  /**
   * The runner is in the process of being deleted.
   *
   * @generated from enum value: RUNNER_PHASE_DELETING = 4;
   */
  DELETING = 4,

  /**
   * The runner has been deleted.
   *
   * @generated from enum value: RUNNER_PHASE_DELETED = 5;
   */
  DELETED = 5,

  /**
   * The runner is in a degraded state.
   *
   * @generated from enum value: RUNNER_PHASE_DEGRADED = 6;
   */
  DEGRADED = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(RunnerPhase)
proto3.util.setEnumType(RunnerPhase, "gitpod.v1.RunnerPhase", [
  { no: 0, name: "RUNNER_PHASE_UNSPECIFIED" },
  { no: 1, name: "RUNNER_PHASE_CREATED" },
  { no: 2, name: "RUNNER_PHASE_INACTIVE" },
  { no: 3, name: "RUNNER_PHASE_ACTIVE" },
  { no: 4, name: "RUNNER_PHASE_DELETING" },
  { no: 5, name: "RUNNER_PHASE_DELETED" },
  { no: 6, name: "RUNNER_PHASE_DEGRADED" },
]);

/**
 * @generated from enum gitpod.v1.RunnerCapability
 */
export enum RunnerCapability {
  /**
   * @generated from enum value: RUNNER_CAPABILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * RUNNER_CAPABILITY_FETCH_LOCAL_SCM_INTEGRATIONS is used by local runners to indicate they support fetching SCM Integrations.
   *
   * @generated from enum value: RUNNER_CAPABILITY_FETCH_LOCAL_SCM_INTEGRATIONS = 1;
   */
  FETCH_LOCAL_SCM_INTEGRATIONS = 1,

  /**
   * RUNNER_CAPABILITY_SECRET_CONTAINER_REGISTRY is used by runners to indicate they support secret container registries.
   *
   * @generated from enum value: RUNNER_CAPABILITY_SECRET_CONTAINER_REGISTRY = 2;
   */
  SECRET_CONTAINER_REGISTRY = 2,

  /**
   * RUNNER_CAPABILITY_AGENT_EXECUTION is used by runners to indicate they support agent execution.
   *
   * @generated from enum value: RUNNER_CAPABILITY_AGENT_EXECUTION = 3;
   */
  AGENT_EXECUTION = 3,

  /**
   * RUNNER_CAPABILITY_ALLOW_ENV_TOKEN_POPULATION is used by runners to indicate they support population of the environment token.
   *
   * @generated from enum value: RUNNER_CAPABILITY_ALLOW_ENV_TOKEN_POPULATION = 4;
   */
  ALLOW_ENV_TOKEN_POPULATION = 4,

  /**
   * RUNNER_CAPABILITY_DEFAULT_DEV_CONTAINER_IMAGE is used by runners to indicate they support the default dev container image.
   *
   * @generated from enum value: RUNNER_CAPABILITY_DEFAULT_DEV_CONTAINER_IMAGE = 5;
   */
  DEFAULT_DEV_CONTAINER_IMAGE = 5,

  /**
   * RUNNER_CAPABILITY_ENVIRONMENT_SNAPSHOT is used by runners to indicate they support taking a snapshot of an environment.
   *
   * @generated from enum value: RUNNER_CAPABILITY_ENVIRONMENT_SNAPSHOT = 6;
   */
  ENVIRONMENT_SNAPSHOT = 6,

  /**
   * RUNNER_CAPABILITY_PREBUILDS_BEFORE_SNAPSHOT_TRIGGER is used by runners to indicate they support the before_snapshot automation trigger.
   * This trigger fires after prebuild tasks complete but before the snapshot is taken.
   *
   * @generated from enum value: RUNNER_CAPABILITY_PREBUILDS_BEFORE_SNAPSHOT_TRIGGER = 7;
   */
  PREBUILDS_BEFORE_SNAPSHOT_TRIGGER = 7,

  /**
   * RUNNER_CAPABILITY_LIST_SCM_ORGANIZATIONS is used by runners to indicate they support listing SCM organizations.
   *
   * @generated from enum value: RUNNER_CAPABILITY_LIST_SCM_ORGANIZATIONS = 8;
   */
  LIST_SCM_ORGANIZATIONS = 8,

  /**
   * RUNNER_CAPABILITY_CHECK_REPOSITORY_ACCESS is used by runners to indicate they support checking repository access.
   *
   * @generated from enum value: RUNNER_CAPABILITY_CHECK_REPOSITORY_ACCESS = 9;
   */
  CHECK_REPOSITORY_ACCESS = 9,

  /**
   * RUNNER_CAPABILITY_RUNNER_SIDE_AGENT is used by runners to indicate they support runner-side agent execution.
   *
   * @generated from enum value: RUNNER_CAPABILITY_RUNNER_SIDE_AGENT = 10;
   */
  RUNNER_SIDE_AGENT = 10,

  /**
   * RUNNER_CAPABILITY_WARM_POOL is used by runners to indicate they support warm pools.
   *
   * @generated from enum value: RUNNER_CAPABILITY_WARM_POOL = 11;
   */
  WARM_POOL = 11,
}
// Retrieve enum metadata with: proto3.getEnumType(RunnerCapability)
proto3.util.setEnumType(RunnerCapability, "gitpod.v1.RunnerCapability", [
  { no: 0, name: "RUNNER_CAPABILITY_UNSPECIFIED" },
  { no: 1, name: "RUNNER_CAPABILITY_FETCH_LOCAL_SCM_INTEGRATIONS" },
  { no: 2, name: "RUNNER_CAPABILITY_SECRET_CONTAINER_REGISTRY" },
  { no: 3, name: "RUNNER_CAPABILITY_AGENT_EXECUTION" },
  { no: 4, name: "RUNNER_CAPABILITY_ALLOW_ENV_TOKEN_POPULATION" },
  { no: 5, name: "RUNNER_CAPABILITY_DEFAULT_DEV_CONTAINER_IMAGE" },
  { no: 6, name: "RUNNER_CAPABILITY_ENVIRONMENT_SNAPSHOT" },
  { no: 7, name: "RUNNER_CAPABILITY_PREBUILDS_BEFORE_SNAPSHOT_TRIGGER" },
  { no: 8, name: "RUNNER_CAPABILITY_LIST_SCM_ORGANIZATIONS" },
  { no: 9, name: "RUNNER_CAPABILITY_CHECK_REPOSITORY_ACCESS" },
  { no: 10, name: "RUNNER_CAPABILITY_RUNNER_SIDE_AGENT" },
  { no: 11, name: "RUNNER_CAPABILITY_WARM_POOL" },
]);

/**
 * @generated from enum gitpod.v1.RunnerRole
 */
export enum RunnerRole {
  /**
   * @generated from enum value: RUNNER_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RUNNER_ROLE_ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * @generated from enum value: RUNNER_ROLE_USER = 2;
   */
  USER = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(RunnerRole)
proto3.util.setEnumType(RunnerRole, "gitpod.v1.RunnerRole", [
  { no: 0, name: "RUNNER_ROLE_UNSPECIFIED" },
  { no: 1, name: "RUNNER_ROLE_ADMIN" },
  { no: 2, name: "RUNNER_ROLE_USER" },
]);

/**
 * @generated from message gitpod.v1.CreateRunnerRequest
 */
export class CreateRunnerRequest extends Message<CreateRunnerRequest> {
  /**
   * The runner name for humans
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * The runner's kind
   * This field is optional and here for backwards-compatibility. Use the provider field instead.
   * If provider is set, the runner's kind will be deduced from the provider.
   * Only one of kind and provider must be set.
   *
   * @generated from field: gitpod.v1.RunnerKind kind = 2;
   */
  kind = RunnerKind.UNSPECIFIED;

  /**
   * @generated from field: gitpod.v1.RunnerSpec spec = 3;
   */
  spec?: RunnerSpec;

  /**
   * The specific implementation type of the runner
   * This field is optional for backwards compatibility but will be required in the future.
   * When specified, kind must not be specified (will be deduced from provider)
   *
   * @generated from field: gitpod.v1.RunnerProvider provider = 4;
   */
  provider = RunnerProvider.UNSPECIFIED;

  /**
   * The runner manager id specifies the runner manager for the managed runner.
   * This field is mandatory for managed runners, otheriwse should not be set.
   *
   * @generated from field: string runner_manager_id = 5;
   */
  runnerManagerId = "";

  constructor(data?: PartialMessage<CreateRunnerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRunnerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "enum", T: proto3.getEnumType(RunnerKind) },
    { no: 3, name: "spec", kind: "message", T: RunnerSpec },
    { no: 4, name: "provider", kind: "enum", T: proto3.getEnumType(RunnerProvider) },
    { no: 5, name: "runner_manager_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRunnerRequest {
    return new CreateRunnerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRunnerRequest {
    return new CreateRunnerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRunnerRequest {
    return new CreateRunnerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRunnerRequest | PlainMessage<CreateRunnerRequest> | undefined, b: CreateRunnerRequest | PlainMessage<CreateRunnerRequest> | undefined): boolean {
    return proto3.util.equals(CreateRunnerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateRunnerResponse
 */
export class CreateRunnerResponse extends Message<CreateRunnerResponse> {
  /**
   * @generated from field: gitpod.v1.Runner runner = 1;
   */
  runner?: Runner;

  /**
   * deprecated, will be removed. Use exchange_token instead.
   *
   * @generated from field: string access_token = 2 [deprecated = true];
   * @deprecated
   */
  accessToken = "";

  /**
   * exchange_token is a one-time use token that should be exchanged by the runner for an access token,
   * using the IdentityService.ExchangeToken rpc. The token expires after 24 hours.
   *
   * @generated from field: string exchange_token = 3;
   */
  exchangeToken = "";

  constructor(data?: PartialMessage<CreateRunnerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRunnerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner", kind: "message", T: Runner },
    { no: 2, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "exchange_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRunnerResponse {
    return new CreateRunnerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRunnerResponse {
    return new CreateRunnerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRunnerResponse {
    return new CreateRunnerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRunnerResponse | PlainMessage<CreateRunnerResponse> | undefined, b: CreateRunnerResponse | PlainMessage<CreateRunnerResponse> | undefined): boolean {
    return proto3.util.equals(CreateRunnerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerRequest
 */
export class GetRunnerRequest extends Message<GetRunnerRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  constructor(data?: PartialMessage<GetRunnerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerRequest {
    return new GetRunnerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerRequest {
    return new GetRunnerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerRequest {
    return new GetRunnerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerRequest | PlainMessage<GetRunnerRequest> | undefined, b: GetRunnerRequest | PlainMessage<GetRunnerRequest> | undefined): boolean {
    return proto3.util.equals(GetRunnerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerResponse
 */
export class GetRunnerResponse extends Message<GetRunnerResponse> {
  /**
   * @generated from field: gitpod.v1.Runner runner = 1;
   */
  runner?: Runner;

  constructor(data?: PartialMessage<GetRunnerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner", kind: "message", T: Runner },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerResponse {
    return new GetRunnerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerResponse {
    return new GetRunnerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerResponse {
    return new GetRunnerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerResponse | PlainMessage<GetRunnerResponse> | undefined, b: GetRunnerResponse | PlainMessage<GetRunnerResponse> | undefined): boolean {
    return proto3.util.equals(GetRunnerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnersRequest
 */
export class ListRunnersRequest extends Message<ListRunnersRequest> {
  /**
   * pagination contains the pagination options for listing runners
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListRunnersRequest.Filter filter = 2;
   */
  filter?: ListRunnersRequest_Filter;

  constructor(data?: PartialMessage<ListRunnersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListRunnersRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnersRequest {
    return new ListRunnersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnersRequest {
    return new ListRunnersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnersRequest {
    return new ListRunnersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnersRequest | PlainMessage<ListRunnersRequest> | undefined, b: ListRunnersRequest | PlainMessage<ListRunnersRequest> | undefined): boolean {
    return proto3.util.equals(ListRunnersRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnersRequest.Filter
 */
export class ListRunnersRequest_Filter extends Message<ListRunnersRequest_Filter> {
  /**
   * creator_ids filters the response to only runner created by specified users
   *
   * @generated from field: repeated string creator_ids = 1;
   */
  creatorIds: string[] = [];

  /**
   * kinds filters the response to only runners of the specified kinds
   *
   * @generated from field: repeated gitpod.v1.RunnerKind kinds = 2;
   */
  kinds: RunnerKind[] = [];

  /**
   * providers filters the response to only runners of the specified providers
   *
   * @generated from field: repeated gitpod.v1.RunnerProvider providers = 3;
   */
  providers: RunnerProvider[] = [];

  constructor(data?: PartialMessage<ListRunnersRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnersRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "creator_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "kinds", kind: "enum", T: proto3.getEnumType(RunnerKind), repeated: true },
    { no: 3, name: "providers", kind: "enum", T: proto3.getEnumType(RunnerProvider), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnersRequest_Filter {
    return new ListRunnersRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnersRequest_Filter {
    return new ListRunnersRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnersRequest_Filter {
    return new ListRunnersRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnersRequest_Filter | PlainMessage<ListRunnersRequest_Filter> | undefined, b: ListRunnersRequest_Filter | PlainMessage<ListRunnersRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListRunnersRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnersResponse
 */
export class ListRunnersResponse extends Message<ListRunnersResponse> {
  /**
   * pagination contains the pagination options for listing runners
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The runners registered in the scope
   *
   * @generated from field: repeated gitpod.v1.Runner runners = 2;
   */
  runners: Runner[] = [];

  constructor(data?: PartialMessage<ListRunnersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "runners", kind: "message", T: Runner, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnersResponse {
    return new ListRunnersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnersResponse {
    return new ListRunnersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnersResponse {
    return new ListRunnersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnersResponse | PlainMessage<ListRunnersResponse> | undefined, b: ListRunnersResponse | PlainMessage<ListRunnersResponse> | undefined): boolean {
    return proto3.util.equals(ListRunnersResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerRequest
 */
export class UpdateRunnerRequest extends Message<UpdateRunnerRequest> {
  /**
   * runner_id specifies which runner to be updated.
   *
   * +required
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * The runner's name which is shown to users
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional gitpod.v1.UpdateRunnerRequest.Spec spec = 3;
   */
  spec?: UpdateRunnerRequest_Spec;

  constructor(data?: PartialMessage<UpdateRunnerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "spec", kind: "message", T: UpdateRunnerRequest_Spec, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerRequest {
    return new UpdateRunnerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerRequest {
    return new UpdateRunnerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerRequest {
    return new UpdateRunnerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerRequest | PlainMessage<UpdateRunnerRequest> | undefined, b: UpdateRunnerRequest | PlainMessage<UpdateRunnerRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerRequest.RunnerConfiguration
 */
export class UpdateRunnerRequest_RunnerConfiguration extends Message<UpdateRunnerRequest_RunnerConfiguration> {
  /**
   * The release channel the runner is on
   *
   * @generated from field: optional gitpod.v1.RunnerReleaseChannel release_channel = 1;
   */
  releaseChannel?: RunnerReleaseChannel;

  /**
   * auto_update indicates whether the runner should automatically update itself.
   *
   * @generated from field: optional bool auto_update = 2;
   */
  autoUpdate?: boolean;

  /**
   * metrics contains configuration for the runner's metrics collection
   *
   * @generated from field: optional gitpod.v1.UpdateRunnerRequest.MetricsConfiguration metrics = 3;
   */
  metrics?: UpdateRunnerRequest_MetricsConfiguration;

  /**
   * log_level is the log level for the runner
   *
   * @generated from field: optional gitpod.v1.LogLevel log_level = 4;
   */
  logLevel?: LogLevel;

  /**
   * devcontainer_image_cache_enabled controls whether the shared devcontainer build cache is enabled for this runner.
   *
   * @generated from field: optional bool devcontainer_image_cache_enabled = 5;
   */
  devcontainerImageCacheEnabled?: boolean;

  /**
   * update_window defines the daily time window (UTC) during which auto-updates are allowed.
   * start_hour is required. If end_hour is omitted, it defaults to start_hour + 2.
   * Send an empty UpdateWindow (no start_hour or end_hour) to clear a custom window
   * and allow updates at any time.
   *
   * @generated from field: optional gitpod.v1.UpdateWindow update_window = 6;
   */
  updateWindow?: UpdateWindow;

  /**
   * honeycomb_api_key is the plaintext API key for Honeycomb tracing.
   * The backend encrypts it with the runner's public key before storing.
   * This is an internal-only field used for debugging.
   *
   * @generated from field: optional string honeycomb_api_key = 7;
   */
  honeycombApiKey?: string;

  constructor(data?: PartialMessage<UpdateRunnerRequest_RunnerConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerRequest.RunnerConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "release_channel", kind: "enum", T: proto3.getEnumType(RunnerReleaseChannel), opt: true },
    { no: 2, name: "auto_update", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "metrics", kind: "message", T: UpdateRunnerRequest_MetricsConfiguration, opt: true },
    { no: 4, name: "log_level", kind: "enum", T: proto3.getEnumType(LogLevel), opt: true },
    { no: 5, name: "devcontainer_image_cache_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "update_window", kind: "message", T: UpdateWindow, opt: true },
    { no: 7, name: "honeycomb_api_key", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerRequest_RunnerConfiguration {
    return new UpdateRunnerRequest_RunnerConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerRequest_RunnerConfiguration {
    return new UpdateRunnerRequest_RunnerConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerRequest_RunnerConfiguration {
    return new UpdateRunnerRequest_RunnerConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerRequest_RunnerConfiguration | PlainMessage<UpdateRunnerRequest_RunnerConfiguration> | undefined, b: UpdateRunnerRequest_RunnerConfiguration | PlainMessage<UpdateRunnerRequest_RunnerConfiguration> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerRequest_RunnerConfiguration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerRequest.MetricsConfiguration
 */
export class UpdateRunnerRequest_MetricsConfiguration extends Message<UpdateRunnerRequest_MetricsConfiguration> {
  /**
   * enabled indicates whether the runner should collect metrics
   *
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * url is the URL of the metrics collector
   *
   * @generated from field: optional string url = 2;
   */
  url?: string;

  /**
   * username is the username to use for the metrics collector
   *
   * @generated from field: optional string username = 3;
   */
  username?: string;

  /**
   * password is the password to use for the metrics collector
   *
   * @generated from field: optional string password = 4;
   */
  password?: string;

  constructor(data?: PartialMessage<UpdateRunnerRequest_MetricsConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerRequest.MetricsConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerRequest_MetricsConfiguration {
    return new UpdateRunnerRequest_MetricsConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerRequest_MetricsConfiguration {
    return new UpdateRunnerRequest_MetricsConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerRequest_MetricsConfiguration {
    return new UpdateRunnerRequest_MetricsConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerRequest_MetricsConfiguration | PlainMessage<UpdateRunnerRequest_MetricsConfiguration> | undefined, b: UpdateRunnerRequest_MetricsConfiguration | PlainMessage<UpdateRunnerRequest_MetricsConfiguration> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerRequest_MetricsConfiguration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerRequest.Spec
 */
export class UpdateRunnerRequest_Spec extends Message<UpdateRunnerRequest_Spec> {
  /**
   * @generated from field: optional gitpod.v1.UpdateRunnerRequest.RunnerConfiguration configuration = 1;
   */
  configuration?: UpdateRunnerRequest_RunnerConfiguration;

  /**
   * desired_phase can currently only be updated on local-configuration runners,
   * to toggle whether local runners are allowed for running environments in the
   * organization.
   * Set to:
   * - ACTIVE to enable local runners.
   * - INACTIVE to disable all local runners. Existing local runners and their
   *   environments will stop, and cannot be started again until the desired_phase
   *   is set to ACTIVE. Use this carefully, as it will affect all users in the
   *   organization who use local runners.
   *
   * @generated from field: optional gitpod.v1.RunnerPhase desired_phase = 2;
   */
  desiredPhase?: RunnerPhase;

  constructor(data?: PartialMessage<UpdateRunnerRequest_Spec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerRequest.Spec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "configuration", kind: "message", T: UpdateRunnerRequest_RunnerConfiguration, opt: true },
    { no: 2, name: "desired_phase", kind: "enum", T: proto3.getEnumType(RunnerPhase), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerRequest_Spec {
    return new UpdateRunnerRequest_Spec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerRequest_Spec {
    return new UpdateRunnerRequest_Spec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerRequest_Spec {
    return new UpdateRunnerRequest_Spec().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerRequest_Spec | PlainMessage<UpdateRunnerRequest_Spec> | undefined, b: UpdateRunnerRequest_Spec | PlainMessage<UpdateRunnerRequest_Spec> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerRequest_Spec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerResponse
 */
export class UpdateRunnerResponse extends Message<UpdateRunnerResponse> {
  constructor(data?: PartialMessage<UpdateRunnerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerResponse {
    return new UpdateRunnerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerResponse {
    return new UpdateRunnerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerResponse {
    return new UpdateRunnerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerResponse | PlainMessage<UpdateRunnerResponse> | undefined, b: UpdateRunnerResponse | PlainMessage<UpdateRunnerResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteRunnerRequest
 */
export class DeleteRunnerRequest extends Message<DeleteRunnerRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * force indicates whether the runner should be deleted forcefully.
   * When force deleting a Runner, all Environments on the runner are also force deleted and
   * regular Runner lifecycle is not respected.
   * Force deleting can result in data loss.
   *
   * @generated from field: bool force = 2;
   */
  force = false;

  constructor(data?: PartialMessage<DeleteRunnerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteRunnerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "force", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteRunnerRequest {
    return new DeleteRunnerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteRunnerRequest {
    return new DeleteRunnerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteRunnerRequest {
    return new DeleteRunnerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteRunnerRequest | PlainMessage<DeleteRunnerRequest> | undefined, b: DeleteRunnerRequest | PlainMessage<DeleteRunnerRequest> | undefined): boolean {
    return proto3.util.equals(DeleteRunnerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteRunnerResponse
 */
export class DeleteRunnerResponse extends Message<DeleteRunnerResponse> {
  constructor(data?: PartialMessage<DeleteRunnerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteRunnerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteRunnerResponse {
    return new DeleteRunnerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteRunnerResponse {
    return new DeleteRunnerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteRunnerResponse {
    return new DeleteRunnerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteRunnerResponse | PlainMessage<DeleteRunnerResponse> | undefined, b: DeleteRunnerResponse | PlainMessage<DeleteRunnerResponse> | undefined): boolean {
    return proto3.util.equals(DeleteRunnerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateRunnerTokenRequest
 */
export class CreateRunnerTokenRequest extends Message<CreateRunnerTokenRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  constructor(data?: PartialMessage<CreateRunnerTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRunnerTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRunnerTokenRequest {
    return new CreateRunnerTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRunnerTokenRequest {
    return new CreateRunnerTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRunnerTokenRequest {
    return new CreateRunnerTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRunnerTokenRequest | PlainMessage<CreateRunnerTokenRequest> | undefined, b: CreateRunnerTokenRequest | PlainMessage<CreateRunnerTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateRunnerTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateRunnerTokenResponse
 */
export class CreateRunnerTokenResponse extends Message<CreateRunnerTokenResponse> {
  /**
   * deprecated, will be removed. Use exchange_token instead.
   *
   * @generated from field: string access_token = 1 [deprecated = true];
   * @deprecated
   */
  accessToken = "";

  /**
   * exchange_token is a one-time use token that should be exchanged by the runner for an access token,
   * using the IdentityService.ExchangeToken rpc. The token expires after 24 hours.
   *
   * @generated from field: string exchange_token = 2;
   */
  exchangeToken = "";

  constructor(data?: PartialMessage<CreateRunnerTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRunnerTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "exchange_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRunnerTokenResponse {
    return new CreateRunnerTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRunnerTokenResponse {
    return new CreateRunnerTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRunnerTokenResponse {
    return new CreateRunnerTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRunnerTokenResponse | PlainMessage<CreateRunnerTokenResponse> | undefined, b: CreateRunnerTokenResponse | PlainMessage<CreateRunnerTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateRunnerTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateRunnerLogsTokenRequest
 */
export class CreateRunnerLogsTokenRequest extends Message<CreateRunnerLogsTokenRequest> {
  /**
   * runner_id specifies the runner for which the logs token should be created.
   *
   * +required
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  constructor(data?: PartialMessage<CreateRunnerLogsTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRunnerLogsTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRunnerLogsTokenRequest {
    return new CreateRunnerLogsTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRunnerLogsTokenRequest {
    return new CreateRunnerLogsTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRunnerLogsTokenRequest {
    return new CreateRunnerLogsTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRunnerLogsTokenRequest | PlainMessage<CreateRunnerLogsTokenRequest> | undefined, b: CreateRunnerLogsTokenRequest | PlainMessage<CreateRunnerLogsTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreateRunnerLogsTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateRunnerLogsTokenResponse
 */
export class CreateRunnerLogsTokenResponse extends Message<CreateRunnerLogsTokenResponse> {
  /**
   * access_token is the token that can be used to access the logs and support bundle of the runner
   *
   * @generated from field: string access_token = 1;
   */
  accessToken = "";

  constructor(data?: PartialMessage<CreateRunnerLogsTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRunnerLogsTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRunnerLogsTokenResponse {
    return new CreateRunnerLogsTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRunnerLogsTokenResponse {
    return new CreateRunnerLogsTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRunnerLogsTokenResponse {
    return new CreateRunnerLogsTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRunnerLogsTokenResponse | PlainMessage<CreateRunnerLogsTokenResponse> | undefined, b: CreateRunnerLogsTokenResponse | PlainMessage<CreateRunnerLogsTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreateRunnerLogsTokenResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ParseContextURLRequest
 */
export class ParseContextURLRequest extends Message<ParseContextURLRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * @generated from field: string context_url = 2;
   */
  contextUrl = "";

  constructor(data?: PartialMessage<ParseContextURLRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ParseContextURLRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "context_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ParseContextURLRequest {
    return new ParseContextURLRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ParseContextURLRequest {
    return new ParseContextURLRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ParseContextURLRequest {
    return new ParseContextURLRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ParseContextURLRequest | PlainMessage<ParseContextURLRequest> | undefined, b: ParseContextURLRequest | PlainMessage<ParseContextURLRequest> | undefined): boolean {
    return proto3.util.equals(ParseContextURLRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ParseContextURLResponse
 */
export class ParseContextURLResponse extends Message<ParseContextURLResponse> {
  /**
   * @generated from field: string original_context_url = 1;
   */
  originalContextUrl = "";

  /**
   * @generated from field: gitpod.v1.ParseContextURLResponse.GitContext git = 2;
   */
  git?: ParseContextURLResponse_GitContext;

  /**
   * @generated from field: gitpod.v1.ParseContextURLResponse.PullRequest pr = 4 [deprecated = true];
   * @deprecated
   */
  pr?: ParseContextURLResponse_PullRequest;

  /**
   * @generated from field: gitpod.v1.ParseContextURLResponse.Issue issue = 5;
   */
  issue?: ParseContextURLResponse_Issue;

  /**
   * @generated from field: gitpod.v1.PullRequest pull_request = 6;
   */
  pullRequest?: PullRequest;

  /**
   * project_ids is a list of projects to which the context URL belongs to.
   *
   * @generated from field: repeated string project_ids = 3;
   */
  projectIds: string[] = [];

  /**
   * scm_id is the unique identifier of the SCM provider (e.g., "github", "gitlab", "bitbucket")
   *
   * @generated from field: string scm_id = 7;
   */
  scmId = "";

  constructor(data?: PartialMessage<ParseContextURLResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ParseContextURLResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "original_context_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "git", kind: "message", T: ParseContextURLResponse_GitContext },
    { no: 4, name: "pr", kind: "message", T: ParseContextURLResponse_PullRequest },
    { no: 5, name: "issue", kind: "message", T: ParseContextURLResponse_Issue },
    { no: 6, name: "pull_request", kind: "message", T: PullRequest },
    { no: 3, name: "project_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "scm_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ParseContextURLResponse {
    return new ParseContextURLResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ParseContextURLResponse {
    return new ParseContextURLResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ParseContextURLResponse {
    return new ParseContextURLResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ParseContextURLResponse | PlainMessage<ParseContextURLResponse> | undefined, b: ParseContextURLResponse | PlainMessage<ParseContextURLResponse> | undefined): boolean {
    return proto3.util.equals(ParseContextURLResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ParseContextURLResponse.GitContext
 */
export class ParseContextURLResponse_GitContext extends Message<ParseContextURLResponse_GitContext> {
  /**
   * @generated from field: string clone_url = 1;
   */
  cloneUrl = "";

  /**
   * @generated from field: string branch = 2;
   */
  branch = "";

  /**
   * @generated from field: string commit = 3;
   */
  commit = "";

  /**
   * @generated from field: string host = 4;
   */
  host = "";

  /**
   * @generated from field: string owner = 5;
   */
  owner = "";

  /**
   * @generated from field: string repo = 6;
   */
  repo = "";

  /**
   * @generated from field: string upstream_remote_url = 7;
   */
  upstreamRemoteUrl = "";

  /**
   * @generated from field: string tag = 8;
   */
  tag = "";

  constructor(data?: PartialMessage<ParseContextURLResponse_GitContext>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ParseContextURLResponse.GitContext";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "clone_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "commit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "repo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "upstream_remote_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ParseContextURLResponse_GitContext {
    return new ParseContextURLResponse_GitContext().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ParseContextURLResponse_GitContext {
    return new ParseContextURLResponse_GitContext().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ParseContextURLResponse_GitContext {
    return new ParseContextURLResponse_GitContext().fromJsonString(jsonString, options);
  }

  static equals(a: ParseContextURLResponse_GitContext | PlainMessage<ParseContextURLResponse_GitContext> | undefined, b: ParseContextURLResponse_GitContext | PlainMessage<ParseContextURLResponse_GitContext> | undefined): boolean {
    return proto3.util.equals(ParseContextURLResponse_GitContext, a, b);
  }
}

/**
 * Deprecated: Use top-level PullRequest message instead
 *
 * @generated from message gitpod.v1.ParseContextURLResponse.PullRequest
 */
export class ParseContextURLResponse_PullRequest extends Message<ParseContextURLResponse_PullRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string from_branch = 3;
   */
  fromBranch = "";

  /**
   * @generated from field: string to_branch = 4;
   */
  toBranch = "";

  constructor(data?: PartialMessage<ParseContextURLResponse_PullRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ParseContextURLResponse.PullRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "from_branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "to_branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ParseContextURLResponse_PullRequest {
    return new ParseContextURLResponse_PullRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ParseContextURLResponse_PullRequest {
    return new ParseContextURLResponse_PullRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ParseContextURLResponse_PullRequest {
    return new ParseContextURLResponse_PullRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ParseContextURLResponse_PullRequest | PlainMessage<ParseContextURLResponse_PullRequest> | undefined, b: ParseContextURLResponse_PullRequest | PlainMessage<ParseContextURLResponse_PullRequest> | undefined): boolean {
    return proto3.util.equals(ParseContextURLResponse_PullRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ParseContextURLResponse.Issue
 */
export class ParseContextURLResponse_Issue extends Message<ParseContextURLResponse_Issue> {
  /**
   * id is the source system's ID of this issue, e.g. BNFRD-6100
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  constructor(data?: PartialMessage<ParseContextURLResponse_Issue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ParseContextURLResponse.Issue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ParseContextURLResponse_Issue {
    return new ParseContextURLResponse_Issue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ParseContextURLResponse_Issue {
    return new ParseContextURLResponse_Issue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ParseContextURLResponse_Issue {
    return new ParseContextURLResponse_Issue().fromJsonString(jsonString, options);
  }

  static equals(a: ParseContextURLResponse_Issue | PlainMessage<ParseContextURLResponse_Issue> | undefined, b: ParseContextURLResponse_Issue | PlainMessage<ParseContextURLResponse_Issue> | undefined): boolean {
    return proto3.util.equals(ParseContextURLResponse_Issue, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ParseContextURLPreconditionFailureDetails
 */
export class ParseContextURLPreconditionFailureDetails extends Message<ParseContextURLPreconditionFailureDetails> {
  /**
   * @generated from field: string authentication_required_url = 1;
   */
  authenticationRequiredUrl = "";

  /**
   * @generated from field: string scm_id = 2;
   */
  scmId = "";

  /**
   * if trying to parse a context URL without specifying a runner, runner_ids will be populated
   * with possible runners that can be authenticated against to access the context URL.
   * This is only populated if no authenticated runner against the context URL is found for the user.
   *
   * @generated from field: repeated string runner_ids = 3;
   */
  runnerIds: string[] = [];

  constructor(data?: PartialMessage<ParseContextURLPreconditionFailureDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ParseContextURLPreconditionFailureDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "authentication_required_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "scm_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "runner_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ParseContextURLPreconditionFailureDetails {
    return new ParseContextURLPreconditionFailureDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ParseContextURLPreconditionFailureDetails {
    return new ParseContextURLPreconditionFailureDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ParseContextURLPreconditionFailureDetails {
    return new ParseContextURLPreconditionFailureDetails().fromJsonString(jsonString, options);
  }

  static equals(a: ParseContextURLPreconditionFailureDetails | PlainMessage<ParseContextURLPreconditionFailureDetails> | undefined, b: ParseContextURLPreconditionFailureDetails | PlainMessage<ParseContextURLPreconditionFailureDetails> | undefined): boolean {
    return proto3.util.equals(ParseContextURLPreconditionFailureDetails, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SearchRepositoriesRequest
 */
export class SearchRepositoriesRequest extends Message<SearchRepositoriesRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * Search query - interpretation depends on search_mode
   *
   * @generated from field: string search_string = 2;
   */
  searchString = "";

  /**
   * Maximum number of repositories to return.
   * Default: 25, Maximum: 100
   * Deprecated: Use pagination.page_size instead
   *
   * @generated from field: int32 limit = 3 [deprecated = true];
   * @deprecated
   */
  limit = 0;

  /**
   * Pagination parameters for repository search
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequest;

  /**
   * The SCM's host to retrieve repositories from
   *
   * @generated from field: string scm_host = 5;
   */
  scmHost = "";

  /**
   * Search mode determines how search_string is interpreted
   *
   * @generated from field: gitpod.v1.SearchMode search_mode = 6;
   */
  searchMode = SearchMode.UNSPECIFIED;

  constructor(data?: PartialMessage<SearchRepositoriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SearchRepositoriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "search_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 5, name: "scm_host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "search_mode", kind: "enum", T: proto3.getEnumType(SearchMode) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchRepositoriesRequest {
    return new SearchRepositoriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchRepositoriesRequest {
    return new SearchRepositoriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchRepositoriesRequest {
    return new SearchRepositoriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchRepositoriesRequest | PlainMessage<SearchRepositoriesRequest> | undefined, b: SearchRepositoriesRequest | PlainMessage<SearchRepositoriesRequest> | undefined): boolean {
    return proto3.util.equals(SearchRepositoriesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SearchRepositoriesResponse
 */
export class SearchRepositoriesResponse extends Message<SearchRepositoriesResponse> {
  /**
   * List of repositories matching the search criteria
   *
   * @generated from field: repeated gitpod.v1.SearchRepositoriesResponse.Repository repositories = 1;
   */
  repositories: SearchRepositoriesResponse_Repository[] = [];

  /**
   * Pagination information for the response.
   * Token format: "NEXT_PAGE/TOTAL_PAGES/TOTAL_COUNT" (e.g., "2/40/1000").
   * Use -1 for unknown values (e.g., "2/-1/-1" when totals unavailable).
   * Empty token means no more pages.
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;

  /**
   * Deprecated: Use pagination token instead. Total pages can be extracted from token.
   *
   * @generated from field: int32 last_page = 3;
   */
  lastPage = 0;

  constructor(data?: PartialMessage<SearchRepositoriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SearchRepositoriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "repositories", kind: "message", T: SearchRepositoriesResponse_Repository, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 3, name: "last_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchRepositoriesResponse {
    return new SearchRepositoriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchRepositoriesResponse {
    return new SearchRepositoriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchRepositoriesResponse {
    return new SearchRepositoriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchRepositoriesResponse | PlainMessage<SearchRepositoriesResponse> | undefined, b: SearchRepositoriesResponse | PlainMessage<SearchRepositoriesResponse> | undefined): boolean {
    return proto3.util.equals(SearchRepositoriesResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SearchRepositoriesResponse.Repository
 */
export class SearchRepositoriesResponse_Repository extends Message<SearchRepositoriesResponse_Repository> {
  /**
   * Repository name (e.g., "my-project")
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * Repository URL (e.g., "https://github.com/owner/my-project")
   *
   * @generated from field: string url = 2;
   */
  url = "";

  constructor(data?: PartialMessage<SearchRepositoriesResponse_Repository>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SearchRepositoriesResponse.Repository";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchRepositoriesResponse_Repository {
    return new SearchRepositoriesResponse_Repository().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchRepositoriesResponse_Repository {
    return new SearchRepositoriesResponse_Repository().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchRepositoriesResponse_Repository {
    return new SearchRepositoriesResponse_Repository().fromJsonString(jsonString, options);
  }

  static equals(a: SearchRepositoriesResponse_Repository | PlainMessage<SearchRepositoriesResponse_Repository> | undefined, b: SearchRepositoriesResponse_Repository | PlainMessage<SearchRepositoriesResponse_Repository> | undefined): boolean {
    return proto3.util.equals(SearchRepositoriesResponse_Repository, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSCMOrganizationsRequest
 */
export class ListSCMOrganizationsRequest extends Message<ListSCMOrganizationsRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * The SCM host to list organizations from (e.g., "github.com", "gitlab.com")
   *
   * @generated from field: string scm_host = 2;
   */
  scmHost = "";

  constructor(data?: PartialMessage<ListSCMOrganizationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSCMOrganizationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "scm_host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSCMOrganizationsRequest {
    return new ListSCMOrganizationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSCMOrganizationsRequest {
    return new ListSCMOrganizationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSCMOrganizationsRequest {
    return new ListSCMOrganizationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSCMOrganizationsRequest | PlainMessage<ListSCMOrganizationsRequest> | undefined, b: ListSCMOrganizationsRequest | PlainMessage<ListSCMOrganizationsRequest> | undefined): boolean {
    return proto3.util.equals(ListSCMOrganizationsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSCMOrganizationsResponse
 */
export class ListSCMOrganizationsResponse extends Message<ListSCMOrganizationsResponse> {
  /**
   * List of organizations the user belongs to
   *
   * @generated from field: repeated gitpod.v1.ListSCMOrganizationsResponse.SCMOrganization organizations = 1;
   */
  organizations: ListSCMOrganizationsResponse_SCMOrganization[] = [];

  constructor(data?: PartialMessage<ListSCMOrganizationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSCMOrganizationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organizations", kind: "message", T: ListSCMOrganizationsResponse_SCMOrganization, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSCMOrganizationsResponse {
    return new ListSCMOrganizationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSCMOrganizationsResponse {
    return new ListSCMOrganizationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSCMOrganizationsResponse {
    return new ListSCMOrganizationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSCMOrganizationsResponse | PlainMessage<ListSCMOrganizationsResponse> | undefined, b: ListSCMOrganizationsResponse | PlainMessage<ListSCMOrganizationsResponse> | undefined): boolean {
    return proto3.util.equals(ListSCMOrganizationsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListSCMOrganizationsResponse.SCMOrganization
 */
export class ListSCMOrganizationsResponse_SCMOrganization extends Message<ListSCMOrganizationsResponse_SCMOrganization> {
  /**
   * Organization name/slug (e.g., "gitpod-io")
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * Organization URL (e.g., "https://github.com/gitpod-io")
   *
   * @generated from field: string url = 2;
   */
  url = "";

  /**
   * Whether the user has admin permissions in this organization.
   * Admin permissions typically allow creating organization-level webhooks.
   *
   * @generated from field: bool is_admin = 3;
   */
  isAdmin = false;

  constructor(data?: PartialMessage<ListSCMOrganizationsResponse_SCMOrganization>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListSCMOrganizationsResponse.SCMOrganization";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_admin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSCMOrganizationsResponse_SCMOrganization {
    return new ListSCMOrganizationsResponse_SCMOrganization().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSCMOrganizationsResponse_SCMOrganization {
    return new ListSCMOrganizationsResponse_SCMOrganization().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSCMOrganizationsResponse_SCMOrganization {
    return new ListSCMOrganizationsResponse_SCMOrganization().fromJsonString(jsonString, options);
  }

  static equals(a: ListSCMOrganizationsResponse_SCMOrganization | PlainMessage<ListSCMOrganizationsResponse_SCMOrganization> | undefined, b: ListSCMOrganizationsResponse_SCMOrganization | PlainMessage<ListSCMOrganizationsResponse_SCMOrganization> | undefined): boolean {
    return proto3.util.equals(ListSCMOrganizationsResponse_SCMOrganization, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CheckAuthenticationForHostRequest
 */
export class CheckAuthenticationForHostRequest extends Message<CheckAuthenticationForHostRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * @generated from field: string host = 2;
   */
  host = "";

  constructor(data?: PartialMessage<CheckAuthenticationForHostRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CheckAuthenticationForHostRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckAuthenticationForHostRequest {
    return new CheckAuthenticationForHostRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckAuthenticationForHostRequest {
    return new CheckAuthenticationForHostRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckAuthenticationForHostRequest {
    return new CheckAuthenticationForHostRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckAuthenticationForHostRequest | PlainMessage<CheckAuthenticationForHostRequest> | undefined, b: CheckAuthenticationForHostRequest | PlainMessage<CheckAuthenticationForHostRequest> | undefined): boolean {
    return proto3.util.equals(CheckAuthenticationForHostRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CheckAuthenticationForHostResponse
 */
export class CheckAuthenticationForHostResponse extends Message<CheckAuthenticationForHostResponse> {
  /**
   * @generated from field: bool authenticated = 1;
   */
  authenticated = false;

  /**
   * @generated from field: string authentication_url = 2 [deprecated = true];
   * @deprecated
   */
  authenticationUrl = "";

  /**
   * @generated from field: bool pat_supported = 3 [deprecated = true];
   * @deprecated
   */
  patSupported = false;

  /**
   * scm_id is the unique identifier of the SCM provider
   *
   * @generated from field: string scm_id = 4;
   */
  scmId = "";

  /**
   * scm_name is the human-readable name of the SCM provider (e.g., "GitHub", "GitLab")
   *
   * @generated from field: string scm_name = 5;
   */
  scmName = "";

  /**
   * supports_oauth2 indicates that the host supports OAuth2 authentication
   *
   * @generated from field: gitpod.v1.CheckAuthenticationForHostResponse.AuthenticationMethodOAuth2 supports_oauth2 = 6;
   */
  supportsOauth2?: CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2;

  /**
   * supports_pat indicates that the host supports Personal Access Token authentication
   *
   * @generated from field: gitpod.v1.CheckAuthenticationForHostResponse.AuthenticationMethodPersonalAccessToken supports_pat = 7;
   */
  supportsPat?: CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken;

  constructor(data?: PartialMessage<CheckAuthenticationForHostResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CheckAuthenticationForHostResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "authenticated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "authentication_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "pat_supported", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "scm_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "scm_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "supports_oauth2", kind: "message", T: CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2 },
    { no: 7, name: "supports_pat", kind: "message", T: CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckAuthenticationForHostResponse {
    return new CheckAuthenticationForHostResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckAuthenticationForHostResponse {
    return new CheckAuthenticationForHostResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckAuthenticationForHostResponse {
    return new CheckAuthenticationForHostResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckAuthenticationForHostResponse | PlainMessage<CheckAuthenticationForHostResponse> | undefined, b: CheckAuthenticationForHostResponse | PlainMessage<CheckAuthenticationForHostResponse> | undefined): boolean {
    return proto3.util.equals(CheckAuthenticationForHostResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CheckAuthenticationForHostResponse.AuthenticationMethodOAuth2
 */
export class CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2 extends Message<CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2> {
  /**
   * auth_url is the URL where users can authenticate
   *
   * @generated from field: string auth_url = 1;
   */
  authUrl = "";

  /**
   * docs_url is the URL to the documentation explaining this authentication method
   *
   * @generated from field: string docs_url = 2;
   */
  docsUrl = "";

  constructor(data?: PartialMessage<CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CheckAuthenticationForHostResponse.AuthenticationMethodOAuth2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "docs_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2 {
    return new CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2 {
    return new CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2 {
    return new CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2().fromJsonString(jsonString, options);
  }

  static equals(a: CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2 | PlainMessage<CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2> | undefined, b: CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2 | PlainMessage<CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2> | undefined): boolean {
    return proto3.util.equals(CheckAuthenticationForHostResponse_AuthenticationMethodOAuth2, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CheckAuthenticationForHostResponse.AuthenticationMethodPersonalAccessToken
 */
export class CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken extends Message<CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken> {
  /**
   * create_url is the URL where users can create a new Personal Access Token
   *
   * @generated from field: string create_url = 1;
   */
  createUrl = "";

  /**
   * docs_url is the URL to the documentation explaining PAT usage for this host
   *
   * @generated from field: string docs_url = 2;
   */
  docsUrl = "";

  /**
   * example is an example of a Personal Access Token
   *
   * @generated from field: string example = 3;
   */
  example = "";

  /**
   * required_scopes is the list of permissions required for the Personal Access Token
   *
   * @generated from field: repeated string required_scopes = 4;
   */
  requiredScopes: string[] = [];

  constructor(data?: PartialMessage<CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CheckAuthenticationForHostResponse.AuthenticationMethodPersonalAccessToken";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "create_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "docs_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "example", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "required_scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken {
    return new CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken {
    return new CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken {
    return new CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken().fromJsonString(jsonString, options);
  }

  static equals(a: CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken | PlainMessage<CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken> | undefined, b: CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken | PlainMessage<CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken> | undefined): boolean {
    return proto3.util.equals(CheckAuthenticationForHostResponse_AuthenticationMethodPersonalAccessToken, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CheckRepositoryAccessRequest
 */
export class CheckRepositoryAccessRequest extends Message<CheckRepositoryAccessRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * repository_url is the URL of the repository to check access for.
   * Can be a clone URL (https://github.com/org/repo.git) or web URL (https://github.com/org/repo).
   *
   * @generated from field: string repository_url = 2;
   */
  repositoryUrl = "";

  constructor(data?: PartialMessage<CheckRepositoryAccessRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CheckRepositoryAccessRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "repository_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckRepositoryAccessRequest {
    return new CheckRepositoryAccessRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckRepositoryAccessRequest {
    return new CheckRepositoryAccessRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckRepositoryAccessRequest {
    return new CheckRepositoryAccessRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckRepositoryAccessRequest | PlainMessage<CheckRepositoryAccessRequest> | undefined, b: CheckRepositoryAccessRequest | PlainMessage<CheckRepositoryAccessRequest> | undefined): boolean {
    return proto3.util.equals(CheckRepositoryAccessRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CheckRepositoryAccessResponse
 */
export class CheckRepositoryAccessResponse extends Message<CheckRepositoryAccessResponse> {
  /**
   * has_access indicates whether the principal has read access to the repository.
   *
   * @generated from field: bool has_access = 1;
   */
  hasAccess = false;

  /**
   * error_message provides details when access check fails.
   * Empty when has_access is true.
   *
   * @generated from field: string error_message = 2;
   */
  errorMessage = "";

  constructor(data?: PartialMessage<CheckRepositoryAccessResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CheckRepositoryAccessResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "has_access", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckRepositoryAccessResponse {
    return new CheckRepositoryAccessResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckRepositoryAccessResponse {
    return new CheckRepositoryAccessResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckRepositoryAccessResponse {
    return new CheckRepositoryAccessResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckRepositoryAccessResponse | PlainMessage<CheckRepositoryAccessResponse> | undefined, b: CheckRepositoryAccessResponse | PlainMessage<CheckRepositoryAccessResponse> | undefined): boolean {
    return proto3.util.equals(CheckRepositoryAccessResponse, a, b);
  }
}

/**
 * ListRunnerPoliciesRequest lists policies for a project.
 *
 * @generated from message gitpod.v1.ListRunnerPoliciesRequest
 */
export class ListRunnerPoliciesRequest extends Message<ListRunnerPoliciesRequest> {
  /**
   * pagination contains the pagination options for listing project policies
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * runner_id specifies the project identifier
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId = "";

  constructor(data?: PartialMessage<ListRunnerPoliciesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerPoliciesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerPoliciesRequest {
    return new ListRunnerPoliciesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerPoliciesRequest {
    return new ListRunnerPoliciesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerPoliciesRequest {
    return new ListRunnerPoliciesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerPoliciesRequest | PlainMessage<ListRunnerPoliciesRequest> | undefined, b: ListRunnerPoliciesRequest | PlainMessage<ListRunnerPoliciesRequest> | undefined): boolean {
    return proto3.util.equals(ListRunnerPoliciesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerPoliciesResponse
 */
export class ListRunnerPoliciesResponse extends Message<ListRunnerPoliciesResponse> {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.RunnerPolicy policies = 2;
   */
  policies: RunnerPolicy[] = [];

  constructor(data?: PartialMessage<ListRunnerPoliciesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerPoliciesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "policies", kind: "message", T: RunnerPolicy, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerPoliciesResponse {
    return new ListRunnerPoliciesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerPoliciesResponse {
    return new ListRunnerPoliciesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerPoliciesResponse {
    return new ListRunnerPoliciesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerPoliciesResponse | PlainMessage<ListRunnerPoliciesResponse> | undefined, b: ListRunnerPoliciesResponse | PlainMessage<ListRunnerPoliciesResponse> | undefined): boolean {
    return proto3.util.equals(ListRunnerPoliciesResponse, a, b);
  }
}

/**
 * CreateRunnerPolicyRequest creates a Runner Policy.
 *
 * @generated from message gitpod.v1.CreateRunnerPolicyRequest
 */
export class CreateRunnerPolicyRequest extends Message<CreateRunnerPolicyRequest> {
  /**
   * runner_id specifies the project identifier
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * group_id specifies the group_id identifier
   *
   * @generated from field: string group_id = 2;
   */
  groupId = "";

  /**
   * @generated from field: gitpod.v1.RunnerRole role = 3;
   */
  role = RunnerRole.UNSPECIFIED;

  constructor(data?: PartialMessage<CreateRunnerPolicyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRunnerPolicyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "enum", T: proto3.getEnumType(RunnerRole) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRunnerPolicyRequest {
    return new CreateRunnerPolicyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRunnerPolicyRequest {
    return new CreateRunnerPolicyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRunnerPolicyRequest {
    return new CreateRunnerPolicyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRunnerPolicyRequest | PlainMessage<CreateRunnerPolicyRequest> | undefined, b: CreateRunnerPolicyRequest | PlainMessage<CreateRunnerPolicyRequest> | undefined): boolean {
    return proto3.util.equals(CreateRunnerPolicyRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateRunnerPolicyResponse
 */
export class CreateRunnerPolicyResponse extends Message<CreateRunnerPolicyResponse> {
  /**
   * @generated from field: gitpod.v1.RunnerPolicy policy = 1;
   */
  policy?: RunnerPolicy;

  constructor(data?: PartialMessage<CreateRunnerPolicyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateRunnerPolicyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "policy", kind: "message", T: RunnerPolicy },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateRunnerPolicyResponse {
    return new CreateRunnerPolicyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateRunnerPolicyResponse {
    return new CreateRunnerPolicyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateRunnerPolicyResponse {
    return new CreateRunnerPolicyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateRunnerPolicyResponse | PlainMessage<CreateRunnerPolicyResponse> | undefined, b: CreateRunnerPolicyResponse | PlainMessage<CreateRunnerPolicyResponse> | undefined): boolean {
    return proto3.util.equals(CreateRunnerPolicyResponse, a, b);
  }
}

/**
 * UpdateRunnerPolicyRequest updates a Project Policy.
 *
 * @generated from message gitpod.v1.UpdateRunnerPolicyRequest
 */
export class UpdateRunnerPolicyRequest extends Message<UpdateRunnerPolicyRequest> {
  /**
   * runner_id specifies the project identifier
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * group_id specifies the group_id identifier
   *
   * @generated from field: string group_id = 2;
   */
  groupId = "";

  /**
   * @generated from field: gitpod.v1.RunnerRole role = 3;
   */
  role = RunnerRole.UNSPECIFIED;

  constructor(data?: PartialMessage<UpdateRunnerPolicyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerPolicyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "role", kind: "enum", T: proto3.getEnumType(RunnerRole) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerPolicyRequest {
    return new UpdateRunnerPolicyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerPolicyRequest {
    return new UpdateRunnerPolicyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerPolicyRequest {
    return new UpdateRunnerPolicyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerPolicyRequest | PlainMessage<UpdateRunnerPolicyRequest> | undefined, b: UpdateRunnerPolicyRequest | PlainMessage<UpdateRunnerPolicyRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerPolicyRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerPolicyResponse
 */
export class UpdateRunnerPolicyResponse extends Message<UpdateRunnerPolicyResponse> {
  /**
   * @generated from field: gitpod.v1.RunnerPolicy policy = 1;
   */
  policy?: RunnerPolicy;

  constructor(data?: PartialMessage<UpdateRunnerPolicyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerPolicyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "policy", kind: "message", T: RunnerPolicy },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerPolicyResponse {
    return new UpdateRunnerPolicyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerPolicyResponse {
    return new UpdateRunnerPolicyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerPolicyResponse {
    return new UpdateRunnerPolicyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerPolicyResponse | PlainMessage<UpdateRunnerPolicyResponse> | undefined, b: UpdateRunnerPolicyResponse | PlainMessage<UpdateRunnerPolicyResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerPolicyResponse, a, b);
  }
}

/**
 * DeleteRunnerPolicyRequest deletes a Project Policy.
 *
 * @generated from message gitpod.v1.DeleteRunnerPolicyRequest
 */
export class DeleteRunnerPolicyRequest extends Message<DeleteRunnerPolicyRequest> {
  /**
   * runner_id specifies the project identifier
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * group_id specifies the group_id identifier
   *
   * @generated from field: string group_id = 2;
   */
  groupId = "";

  constructor(data?: PartialMessage<DeleteRunnerPolicyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteRunnerPolicyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteRunnerPolicyRequest {
    return new DeleteRunnerPolicyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteRunnerPolicyRequest {
    return new DeleteRunnerPolicyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteRunnerPolicyRequest {
    return new DeleteRunnerPolicyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteRunnerPolicyRequest | PlainMessage<DeleteRunnerPolicyRequest> | undefined, b: DeleteRunnerPolicyRequest | PlainMessage<DeleteRunnerPolicyRequest> | undefined): boolean {
    return proto3.util.equals(DeleteRunnerPolicyRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteRunnerPolicyResponse
 */
export class DeleteRunnerPolicyResponse extends Message<DeleteRunnerPolicyResponse> {
  constructor(data?: PartialMessage<DeleteRunnerPolicyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteRunnerPolicyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteRunnerPolicyResponse {
    return new DeleteRunnerPolicyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteRunnerPolicyResponse {
    return new DeleteRunnerPolicyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteRunnerPolicyResponse {
    return new DeleteRunnerPolicyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteRunnerPolicyResponse | PlainMessage<DeleteRunnerPolicyResponse> | undefined, b: DeleteRunnerPolicyResponse | PlainMessage<DeleteRunnerPolicyResponse> | undefined): boolean {
    return proto3.util.equals(DeleteRunnerPolicyResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.Runner
 */
export class Runner extends Message<Runner> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * Time when the Runner was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * Time when the Runner was last udpated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;

  /**
   * The runner's name which is shown to users
   *
   * @generated from field: string name = 4;
   */
  name = "";

  /**
   * The runner's specification
   *
   * @generated from field: gitpod.v1.RunnerSpec spec = 5;
   */
  spec?: RunnerSpec;

  /**
   * The runner's status
   *
   * @generated from field: gitpod.v1.RunnerStatus status = 6;
   */
  status?: RunnerStatus;

  /**
   * creator is the identity of the creator of the environment
   *
   * @generated from field: gitpod.v1.Subject creator = 7;
   */
  creator?: Subject;

  /**
   * The runner's kind
   *
   * @generated from field: gitpod.v1.RunnerKind kind = 8;
   */
  kind = RunnerKind.UNSPECIFIED;

  /**
   * The runner's provider
   *
   * @generated from field: gitpod.v1.RunnerProvider provider = 9;
   */
  provider = RunnerProvider.UNSPECIFIED;

  /**
   * The runner manager id specifies the runner manager for the managed runner.
   * This field is only set for managed runners.
   *
   * @generated from field: string runner_manager_id = 10;
   */
  runnerManagerId = "";

  constructor(data?: PartialMessage<Runner>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Runner";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_at", kind: "message", T: Timestamp },
    { no: 3, name: "updated_at", kind: "message", T: Timestamp },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "spec", kind: "message", T: RunnerSpec },
    { no: 6, name: "status", kind: "message", T: RunnerStatus },
    { no: 7, name: "creator", kind: "message", T: Subject },
    { no: 8, name: "kind", kind: "enum", T: proto3.getEnumType(RunnerKind) },
    { no: 9, name: "provider", kind: "enum", T: proto3.getEnumType(RunnerProvider) },
    { no: 10, name: "runner_manager_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Runner {
    return new Runner().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Runner {
    return new Runner().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Runner {
    return new Runner().fromJsonString(jsonString, options);
  }

  static equals(a: Runner | PlainMessage<Runner> | undefined, b: Runner | PlainMessage<Runner> | undefined): boolean {
    return proto3.util.equals(Runner, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerSpec
 */
export class RunnerSpec extends Message<RunnerSpec> {
  /**
   * @generated from field: gitpod.v1.RunnerPhase desired_phase = 1;
   */
  desiredPhase = RunnerPhase.UNSPECIFIED;

  /**
   * The runner's configuration
   *
   * @generated from field: gitpod.v1.RunnerConfiguration configuration = 2;
   */
  configuration?: RunnerConfiguration;

  /**
   * The runner's variant
   *
   * @generated from field: gitpod.v1.RunnerVariant variant = 3;
   */
  variant = RunnerVariant.UNSPECIFIED;

  constructor(data?: PartialMessage<RunnerSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "desired_phase", kind: "enum", T: proto3.getEnumType(RunnerPhase) },
    { no: 2, name: "configuration", kind: "message", T: RunnerConfiguration },
    { no: 3, name: "variant", kind: "enum", T: proto3.getEnumType(RunnerVariant) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerSpec {
    return new RunnerSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerSpec {
    return new RunnerSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerSpec {
    return new RunnerSpec().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerSpec | PlainMessage<RunnerSpec> | undefined, b: RunnerSpec | PlainMessage<RunnerSpec> | undefined): boolean {
    return proto3.util.equals(RunnerSpec, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerConfiguration
 */
export class RunnerConfiguration extends Message<RunnerConfiguration> {
  /**
   * Region to deploy the runner in, if applicable.
   * This is mainly used for remote runners, and is only a hint. The runner may be
   * deployed in a different region. See the runner's status for the actual region.
   *
   * @generated from field: string region = 1;
   */
  region = "";

  /**
   * The release channel the runner is on
   *
   * @generated from field: gitpod.v1.RunnerReleaseChannel release_channel = 2;
   */
  releaseChannel = RunnerReleaseChannel.UNSPECIFIED;

  /**
   * auto_update indicates whether the runner should automatically update itself.
   *
   * @generated from field: bool auto_update = 3;
   */
  autoUpdate = false;

  /**
   * metrics contains configuration for the runner's metrics collection
   *
   * @generated from field: gitpod.v1.MetricsConfiguration metrics = 4;
   */
  metrics?: MetricsConfiguration;

  /**
   * log_level is the log level for the runner
   *
   * @generated from field: gitpod.v1.LogLevel log_level = 5;
   */
  logLevel = LogLevel.UNSPECIFIED;

  /**
   * devcontainer_image_cache_enabled controls whether the devcontainer build cache is
   * enabled for this runner.
   * Only takes effect on supported runners, currently only AWS EC2 and Gitpod-managed runners.
   *
   * @generated from field: bool devcontainer_image_cache_enabled = 6;
   */
  devcontainerImageCacheEnabled = false;

  /**
   * update_window defines the daily time window (UTC) during which auto-updates are allowed.
   * If not set, updates are allowed at any time.
   *
   * @generated from field: gitpod.v1.UpdateWindow update_window = 7;
   */
  updateWindow?: UpdateWindow;

  /**
   * encrypted_honeycomb_api_key is the Honeycomb API key encrypted with the runner's public key.
   * This is an internal-only field used for debugging and is not exposed in the dashboard UI.
   *
   * @generated from field: bytes encrypted_honeycomb_api_key = 8;
   */
  encryptedHoneycombApiKey = new Uint8Array(0);

  constructor(data?: PartialMessage<RunnerConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "release_channel", kind: "enum", T: proto3.getEnumType(RunnerReleaseChannel) },
    { no: 3, name: "auto_update", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "metrics", kind: "message", T: MetricsConfiguration },
    { no: 5, name: "log_level", kind: "enum", T: proto3.getEnumType(LogLevel) },
    { no: 6, name: "devcontainer_image_cache_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "update_window", kind: "message", T: UpdateWindow },
    { no: 8, name: "encrypted_honeycomb_api_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerConfiguration {
    return new RunnerConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerConfiguration {
    return new RunnerConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerConfiguration {
    return new RunnerConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerConfiguration | PlainMessage<RunnerConfiguration> | undefined, b: RunnerConfiguration | PlainMessage<RunnerConfiguration> | undefined): boolean {
    return proto3.util.equals(RunnerConfiguration, a, b);
  }
}

/**
 * UpdateWindow defines a daily time window (UTC) during which auto-updates are allowed.
 * The window must be at least 2 hours long.
 * Overnight windows are supported (e.g., start_hour=22, end_hour=4).
 *
 * @generated from message gitpod.v1.UpdateWindow
 */
export class UpdateWindow extends Message<UpdateWindow> {
  /**
   * start_hour is the beginning of the update window as a UTC hour (0-23).
   * +required
   *
   * @generated from field: optional uint32 start_hour = 1;
   */
  startHour?: number;

  /**
   * end_hour is the end of the update window as a UTC hour (0-23).
   * If not set, defaults to start_hour + 2.
   *
   * @generated from field: optional uint32 end_hour = 2;
   */
  endHour?: number;

  constructor(data?: PartialMessage<UpdateWindow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateWindow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_hour", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 2, name: "end_hour", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWindow {
    return new UpdateWindow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWindow {
    return new UpdateWindow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWindow {
    return new UpdateWindow().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWindow | PlainMessage<UpdateWindow> | undefined, b: UpdateWindow | PlainMessage<UpdateWindow> | undefined): boolean {
    return proto3.util.equals(UpdateWindow, a, b);
  }
}

/**
 * @generated from message gitpod.v1.MetricsConfiguration
 */
export class MetricsConfiguration extends Message<MetricsConfiguration> {
  /**
   * enabled indicates whether the runner should collect metrics
   *
   * @generated from field: bool enabled = 1;
   */
  enabled = false;

  /**
   * url is the URL of the metrics collector
   *
   * @generated from field: string url = 2;
   */
  url = "";

  /**
   * username is the username to use for the metrics collector
   *
   * @generated from field: string username = 3;
   */
  username = "";

  /**
   * password is the password to use for the metrics collector
   *
   * @generated from field: string password = 4;
   */
  password = "";

  constructor(data?: PartialMessage<MetricsConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.MetricsConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MetricsConfiguration {
    return new MetricsConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MetricsConfiguration {
    return new MetricsConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MetricsConfiguration {
    return new MetricsConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: MetricsConfiguration | PlainMessage<MetricsConfiguration> | undefined, b: MetricsConfiguration | PlainMessage<MetricsConfiguration> | undefined): boolean {
    return proto3.util.equals(MetricsConfiguration, a, b);
  }
}

/**
 * RunnerStatus represents the status of a runner
 *
 * @generated from message gitpod.v1.RunnerStatus
 */
export class RunnerStatus extends Message<RunnerStatus> {
  /**
   * Time when the status was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string version = 2;
   */
  version = "";

  /**
   * @generated from field: string system_details = 3;
   */
  systemDetails = "";

  /**
   * The runner's reported phase
   *
   * @generated from field: gitpod.v1.RunnerPhase phase = 4;
   */
  phase = RunnerPhase.UNSPECIFIED;

  /**
   * @generated from field: string log_url = 5;
   */
  logUrl = "";

  /**
   * The runner's reported message which is shown to users.
   * This message adds more context to the runner's phase.
   *
   * @generated from field: string message = 6;
   */
  message = "";

  /**
   * region is the region the runner is running in, if applicable.
   *
   * @generated from field: string region = 7;
   */
  region = "";

  /**
   * additional_info contains additional information about the runner,
   * e.g. a CloudFormation stack URL.
   *
   * @generated from field: repeated gitpod.v1.FieldValue additional_info = 8;
   */
  additionalInfo: FieldValue[] = [];

  /**
   * capabilities is a list of capabilities the runner supports.
   *
   * @generated from field: repeated gitpod.v1.RunnerCapability capabilities = 9;
   */
  capabilities: RunnerCapability[] = [];

  /**
   * gateway_info is information about the gateway to which the runner is connected.
   *
   * @generated from field: gitpod.v1.GatewayInfo gateway_info = 10;
   */
  gatewayInfo?: GatewayInfo;

  /**
   * llm_url is the URL of the LLM service to which the runner is connected.
   *
   * @generated from field: string llm_url = 11;
   */
  llmUrl = "";

  /**
   * public_key is the runner's public key used for encryption (32 bytes)
   *
   * @generated from field: bytes public_key = 12;
   */
  publicKey = new Uint8Array(0);

  /**
   * support_bundle_url is the URL at which the runner support bundle can be accessed.
   * This URL provides access to pprof profiles and other debug information.
   * Only available for standalone runners.
   *
   * @generated from field: string support_bundle_url = 13;
   */
  supportBundleUrl = "";

  constructor(data?: PartialMessage<RunnerStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "updated_at", kind: "message", T: Timestamp },
    { no: 2, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "system_details", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "phase", kind: "enum", T: proto3.getEnumType(RunnerPhase) },
    { no: 5, name: "log_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "additional_info", kind: "message", T: FieldValue, repeated: true },
    { no: 9, name: "capabilities", kind: "enum", T: proto3.getEnumType(RunnerCapability), repeated: true },
    { no: 10, name: "gateway_info", kind: "message", T: GatewayInfo },
    { no: 11, name: "llm_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "public_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 13, name: "support_bundle_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerStatus {
    return new RunnerStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerStatus {
    return new RunnerStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerStatus {
    return new RunnerStatus().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerStatus | PlainMessage<RunnerStatus> | undefined, b: RunnerStatus | PlainMessage<RunnerStatus> | undefined): boolean {
    return proto3.util.equals(RunnerStatus, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GatewayInfo
 */
export class GatewayInfo extends Message<GatewayInfo> {
  /**
   * @generated from field: gitpod.v1.Gateway gateway = 1;
   */
  gateway?: Gateway;

  /**
   * latency is the round-trip time of the runner to the gateway in milliseconds.
   *
   * @generated from field: google.protobuf.Duration latency = 2;
   */
  latency?: Duration;

  constructor(data?: PartialMessage<GatewayInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GatewayInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gateway", kind: "message", T: Gateway },
    { no: 2, name: "latency", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GatewayInfo {
    return new GatewayInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GatewayInfo {
    return new GatewayInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GatewayInfo {
    return new GatewayInfo().fromJsonString(jsonString, options);
  }

  static equals(a: GatewayInfo | PlainMessage<GatewayInfo> | undefined, b: GatewayInfo | PlainMessage<GatewayInfo> | undefined): boolean {
    return proto3.util.equals(GatewayInfo, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerPolicy
 */
export class RunnerPolicy extends Message<RunnerPolicy> {
  /**
   * @generated from field: string group_id = 1;
   */
  groupId = "";

  /**
   * role is the role assigned to the group
   *
   * @generated from field: gitpod.v1.RunnerRole role = 2;
   */
  role = RunnerRole.UNSPECIFIED;

  constructor(data?: PartialMessage<RunnerPolicy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerPolicy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(RunnerRole) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerPolicy {
    return new RunnerPolicy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerPolicy {
    return new RunnerPolicy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerPolicy {
    return new RunnerPolicy().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerPolicy | PlainMessage<RunnerPolicy> | undefined, b: RunnerPolicy | PlainMessage<RunnerPolicy> | undefined): boolean {
    return proto3.util.equals(RunnerPolicy, a, b);
  }
}

